import './index.css'
import '../../../global/css/global-display.css'
import '../../../global/css/font-style.css'
import '../../../global/css/container.css'
import React, {useContext, useEffect, useRef, useState} from "react";

import GridLetterCard from "./component/GridLetterCard/GridLetterCard.tsx";
import Keyboard from "./component/Keyboard/Keyboard.tsx";
import ExitGameConfirmDialog from "./component/ExitGameConfirmDialog/ExitGameConfirmDialog.tsx";
import ChallengeGameFailDialog from "./component/ChallengeGameFailDialog.tsx";
import html2canvas from "html2canvas";
import {PageEnum} from "../../../types/IPage.ts";
import {ThemeContext} from "../../../providers/themeContext/theme-context.tsx";
import {useUserContext} from "../../../providers/userProvider/user-context.tsx";
import {useMusicContext} from "../../../providers/musicProvider/music-player-context.tsx";
import {LocalStorageKey} from "../../../types/IGameStat.ts";
import SettingModal from "../../home/component/SettingModal.tsx";
import AiTopBar from "./component/AITopBar/AITopBar.tsx";
import {GAEvents} from "../../../common/utils/GA4/GAEvents.ts";
import {ToastContext} from "../../../components/CustomToast/ToastProvider.tsx";
import {UrlConfig} from "../../../common/config/url-config.ts";
import AIPlayTipModal from "./component/how_to_play_tips/AIPlayTipsModal.tsx";
import {ShareUtil} from "../../../common/utils/share-util/shareUtil.ts";
import {apiService} from "../../../common/utils/http/api-service.ts";
import {IAIGameResult} from "../../../common/utils/http/IParams.ts";
import useLoading from "../../../providers/loadingContext/useLoading.ts";

interface Props {
    currentPage?: PageEnum;
    switchPage: (page: PageEnum) => void;
    handleGameWinReward: (gameType: string) => void;
    handleShareReward: () => void;
}

// 游戏页面
const AIGamePage: React.FC<Props> = ({switchPage, handleGameWinReward, handleShareReward}) => {
    const {addToast} = useContext(ToastContext);
    // 主题全局管理器
    const {imgUrls, theme} = useContext(ThemeContext);
    const {showLoading, hideLoading} = useLoading();
    // 全局用户信息provider
    const {user, challengeWords, aiLevel, setAiLevel} = useUserContext();
    // 全局音乐provider
    const musicManager = useMusicContext();
    const targetRef = useRef<HTMLDivElement>(null)
    // 顶部机器人五个方形格子的背景图
    const [squares, setSquares] = useState([imgUrls.letterAllWrongBgUrl, imgUrls.letterAllWrongBgUrl, imgUrls.letterAllWrongBgUrl, imgUrls.letterAllWrongBgUrl, imgUrls.letterAllWrongBgUrl]);

    // 是否正在截图
    const [isScreenshotting, setIsScreenshotting] = useState<boolean>(false)
    // 是否显示AI挑战失败的弹窗提示
    const [showAiGameFailTip, setShowAiGameFailTip] = useState<boolean>(false)
    // 是否显示退出游戏确认弹窗
    const [showExitConfirm, setShowExitConfirm] = useState<boolean>(false)
    // 是否显示游戏提示
    const [showPlayTip, setShowPlayTip] = useState<boolean>(false)
    // 是否弹出设置弹窗
    const [showSetting, setShowSetting] = useState<boolean>(false)
    // 已经输入的单词列表
    const [inputWords, setInputWords] = useState<string[]>([])
    // 正确的单词
    const [correctWord, setCorrectWord] = useState<string>("");
    // 已经输入的单词列表里所有错误的字母，不可重复
    const [wrongLetters, setWrongLetters] = useState<string[]>([])
    const [totalHardTime, setTotalHardTime] = useState<number>(1800)
    // 机器人倒计时的秒数时间
    const [hardTime, setHardTime] = useState<number>(1800)
    // 机器人思考的时间
    const [aiTime, setAiTIme] = useState<number>(72)
    // 正计时
    const [countUp, setCountUp] = useState<number>(0)
    // 间隔时间,每次用户思考的时间
    const [thinkTime, setThinkTime] = useState<number>(0)
    // AI Bar的变化次数
    const [aiBarChangeTimes, setAiBarChangeTimes] = useState<number>(0)
    // 游戏状态，1开始，2结束【输了】，3结束【赢了】。 一进来就是开始
    const [gameState, setGameState] = useState<number>(1)
    // 是否提交
    const [isSubmit, setIsSubmit] = useState<boolean>(false)
    // 最高级别，结束后返回
    const [bestStreak, setBestStreak] = useState<number>(0)


    useEffect(() => {
        if (isSubmit) {
            submitResult()
            if (gameState === 3) {
                // 如果是胜利
                handleGameWinReward("ai_challenge");
            }
        }
    }, [isSubmit, inputWords, gameState]);

    // 游戏结束提交游戏结果到后端
    const submitResult = async () => {
        const params: IAIGameResult = {
            level: aiLevel,
            hasWin: gameState === 3,
            correctWord: correctWord,
            totalWords: inputWords,
            playTimes: countUp,
        }
        const response = await apiService.submitAiGameResult(params)
        if (response.code === 200) {
            setBestStreak(response.data)
        }
    }

    // 单词错误时，就调用一次方法，将thinkTime重置为0重新计时
    const enterWrongWord = () => {
        // 将思考的时间加上
        const countTime = 120 + thinkTime;
        // 将hardTime整体扣除
        setHardTime(hardTime - countTime)
        setThinkTime(0)
    }

    // 游戏中逐步改变顶部五个方格子的背景图
    const changeAiTopBar = (num: number) => {
        let copySquares = [...squares];
        // 如果num传入的值是2，就调用两次方法
        for (let i = 0; i < num; i++) {
            // 每变化一次，就添加一次ai变化次数
            setAiBarChangeTimes(aiBarChangeTimes + 1);
            const indices: number[] = [];
            // 找出所有squares中不等于imgUrls.letterAllRight的所有index，并返回index列表
            copySquares.forEach((element, index) => {
                if (element !== imgUrls.letterAllRight) {
                    indices.push(index);
                }
            });
            // 在indices中随机取一个index
            const randomIndex = indices[Math.floor(Math.random() * indices.length)];
            if (squares[randomIndex] === imgUrls.letterAllWrongBgUrl) {
                const newSquares = [...copySquares];
                newSquares[randomIndex] = imgUrls.letterWrongPositionUrl;
                copySquares = [...newSquares]
                setSquares([...newSquares]);
            } else {
                const newSquares = [...copySquares];
                newSquares[randomIndex] = imgUrls.letterAllRight;
                copySquares = [...newSquares]
                setSquares(newSquares);
            }
        }
    }

    // hardTime进行倒计时，每隔aiTime
    useEffect(() => {
        const intervalHardTime = setInterval(() => {
            setHardTime(hardTime - 1)
            // 计算已经减少的时间和总数相差多少
            const diff = totalHardTime - hardTime;
            // 将diff除以aiTime的出整数部分
            const count = Math.floor(diff / aiTime);
            const countNum = count - aiBarChangeTimes;
            changeAiTopBar(countNum);
            setAiBarChangeTimes(aiBarChangeTimes + countNum);
        }, 1000);

        // 如果游戏已经结束，停止倒计时
        if (gameState === 2 || gameState === 3) {
            clearInterval(intervalHardTime);
        }

        if (hardTime <= 0) {
            // 如果倒计时结束，就设置为失败
            setGameState(2)
            // 游戏结束调用接口
            setIsSubmit(true)
            clearInterval(intervalHardTime);
        }

        return () => clearInterval(intervalHardTime);
    }, [hardTime])

    useEffect(() => {
        setCorrectWord(challengeWords[aiLevel - 1].word)
    }, [aiLevel]);

    // 间隔时间正计时，每次调用一次就从0开始正计时
    useEffect(() => {
        const intervalThinkTime = setInterval(() => {
            setThinkTime(thinkTime + 1)
        }, 1000);

        return () => clearInterval(intervalThinkTime)
    }, [thinkTime]);

    // 在胜利界面退出的时候，保存：已经输入的单词列表，当前关卡数，游戏时间
    const saveGameStatus = () => {
        localStorage.setItem(LocalStorageKey.AI_CHALLENGE_INPUT_WORDS, JSON.stringify(inputWords));
        localStorage.setItem(LocalStorageKey.AI_CHALLENGE_GAME_LEVEL, aiLevel.toString());
        localStorage.setItem(LocalStorageKey.AI_CHALLENGE_GAME_COUNT_SECONDS, countUp.toString());
        // 这里这个不能在这里保存，不然会导致下次进来显示的正确单词状态不正确
        // localStorage.setItem(LocalStorageKey.AI_CHALLENGE_CORRECT_WORD, correctWord);
    };

    // 在中间直接退出的时候，直接清空所有本地数据
    const clearGameStatus = () => {
        localStorage.removeItem(LocalStorageKey.AI_CHALLENGE_INPUT_WORDS);
        localStorage.removeItem(LocalStorageKey.AI_CHALLENGE_GAME_LEVEL);
        localStorage.removeItem(LocalStorageKey.AI_CHALLENGE_GAME_COUNT_SECONDS);
        localStorage.removeItem(LocalStorageKey.AI_CHALLENGE_CORRECT_WORD);
    };

    // 从本地获取数据，如果已经存在，就保存到页面，并直接显示成功界面
    const loadGameStatus = () => {
        const inputWordsStr = localStorage.getItem(LocalStorageKey.AI_CHALLENGE_INPUT_WORDS);
        const correctWordStr = localStorage.getItem(LocalStorageKey.AI_CHALLENGE_CORRECT_WORD);
        const aiLevelStr = localStorage.getItem(LocalStorageKey.AI_CHALLENGE_GAME_LEVEL);
        const countUpStr = localStorage.getItem(LocalStorageKey.AI_CHALLENGE_GAME_COUNT_SECONDS);
        if (inputWordsStr && aiLevelStr && countUpStr) {
            // 如果本地的级别比进来默认的级别高，就显示历史胜利level，否则重新开始游戏
            if (parseInt(aiLevelStr) >= aiLevel) {
                setInputWords(JSON.parse(inputWordsStr));
                setAiLevel(parseInt(aiLevelStr))
                setCountUp(parseInt(countUpStr))
                setCorrectWord(correctWordStr ?? "")
                setGameState(3)
            }
        } else {

            setAiLevel(1)
        }
    };

    // 页面加载时运行
    useEffect(() => {
        // GA埋点
        GAEvents.aiChallengeGamePageShow()
        loadGameStatus()
        const hardTimeAdd = challengeWords[aiLevel - 1].hard_level === 1 ? 600 : challengeWords[aiLevel - 1].hard_level === 2 ? 300 : 120;
        const hardTimeNum = challengeWords[aiLevel - 1].hard_time + hardTimeAdd
        setTotalHardTime(hardTimeNum)
        setHardTime(hardTimeNum)
        setAiTIme(hardTimeNum / 10)
        showChallengeTipDialog();
    }, []);

    // 从本地存储获取是否已经弹出过提示，如果弹出过，就不要再弹出，否则，就弹出来，然后保存到本地
    const showChallengeTipDialog = () => {
        const dailyTipStatus = localStorage.getItem(LocalStorageKey.CHALLENGE_TIP_STATUS);
        if (dailyTipStatus) {
            return;
        }
        // GA埋点
        GAEvents.howToPlayAutoShow();
        setShowPlayTip(true)
        // 保存标记到本地
        localStorage.setItem(LocalStorageKey.CHALLENGE_TIP_STATUS, "hasShowed")
    }

    // 对组件截图
    const captureScreenshot = async () => {
        // GA埋点
        GAEvents.aiChallengeGameShareClick()

        showLoading()
        setIsScreenshotting(true)

        setTimeout(() => {
            const node = targetRef.current;
            if (node) {
                html2canvas(node, {scale: 2, useCORS: true})
                    .then((canvas) => {
                        // 获取图片dataUrl
                        const dataUrl = canvas.toDataURL('image/png');
                        ShareUtil.share(new URL(UrlConfig.SHARE_URL), (e) => {
                            addToast({type: "warning", message: `Share error：${e}`})
                        }, dataUrl)
                    })
                    .catch((error) => {
                        console.error('Share error', error);
                    }).finally(() => {
                    handleShareReward();
                    setIsScreenshotting(false)
                    hideLoading()
                });
            }
        }, 200)
    };

    // 监控游戏状态，根据状态触发要做的事
    useEffect(() => {
        const interval4 = setInterval(() => {
            setCountUp((prevTime: number) => {
                return prevTime + 1;
            });
        }, 1000);

        // 游戏失败
        if (gameState === 2) {
            // 延迟1秒显示
            setTimeout(() => {
                setSquares([imgUrls.letterAllRight, imgUrls.letterAllRight, imgUrls.letterAllRight, imgUrls.letterAllRight, imgUrls.letterAllRight])
                setShowAiGameFailTip(true)
                musicManager.playFailSound()
                // 如果失败，就清空本地关卡数
                clearGameStatus()
            }, 3000);
            clearInterval(interval4)
        }

        // 如果游戏胜利，播放胜利音效
        if (gameState === 3) {
            musicManager.playSuccessSound()
            // 保存游戏数据到本地
            saveGameStatus()
            clearInterval(interval4)
        }

        // 清除定时器，避免内存泄漏
        return () => clearInterval(interval4);
    }, [gameState]);

    // 设置游戏状态
    const handleGameState = (state: number) => {
        setGameState(state)
    }

    // 向单词列表添加单词
    const addWordToInputList = (word: string) => {
        // 在inputWords第一个的位置添加单词
        setInputWords((prevState) => [word, ...prevState])
        // 每次添加完都判断一次错误单词
        checkWrongLetters(word)
    }

    // 判定输入的单词是否正确，并更新错误单词列表
    const checkWrongLetters = (word: string) => {
        // 首先判断是否正确，如果正确，游戏结束
        if (correctWord === word.toLowerCase()) {
            // 在游戏胜利的时候保存本地正确的单词
            localStorage.setItem(LocalStorageKey.AI_CHALLENGE_CORRECT_WORD, correctWord);
            // 延迟3秒再提示
            setTimeout(() => {
                // 赢了
                handleGameState(3)
                // GA埋点
                GAEvents.aiChallengeGameSuccessShow();
                // 游戏结束调用接口
                setIsSubmit(true)
            }, 3000);
            return
        } else {
            // 如果不正确，就扣除3分钟也就是180秒
            enterWrongWord()
        }

        const letters = word.toLowerCase().split('')

        letters.forEach(letter => {
            if (!correctWord.includes(letter)) {
                setWrongLetters(prevState => [...prevState, letter])
            }
        })
    }

    // 在设置中点击游戏提示
    const showPlayTipModal = () => {
        // 关闭设置弹窗
        setShowSetting(false)
        // 显示游戏提示
        setShowPlayTip(true)
    }

    // 确认退出游戏界面
    const confirmExit = () => {
        // 清空本地存储的关卡数据
        clearGameStatus()
        // 关闭确认弹窗
        setShowExitConfirm(false)
        switchPage(PageEnum.HOME)
    }

    // 返回按钮的点击事件
    const handleBackButton = () => {
        // GA埋点
        GAEvents.aiChallengeGameExitButtonClick()

        if (gameState === 2 || gameState === 3) {
            switchPage(PageEnum.HOME)
            return
        }
        setShowExitConfirm(true)
    }

    // 失败弹窗的关闭事件
    const handleCloseFailModal = () => {
        switchPage(PageEnum.HOME)
    }

    // 跳转到挑战页面
    const toChallengePage = () => {
        //GA埋点
        GAEvents.aiChallengeGameNextLevelClick()

        setAiLevel((prev) => prev + 1)
        switchPage(PageEnum.CHALLENGE)
    }

    // 胜利界面card-挑战模式的背景图样式
    const successCardStyle = (gameState === 3 || gameState === 2) ? {
        marginTop: '75px',
        backgroundImage: `url(${theme?.gameSettlementCardBg ?? imgUrls.youWinCardBgUrl})`,
        transition: 'background-image 1s ease-in-out',
    } : {};

    // 显示设置弹窗
    const showSettingModal = () => {
        // GA埋点
        GAEvents.aiChallengeGameSetting()
        setShowSetting(true)
    }

    // 显示how to play 游戏提示弹窗
    const showHowToPlayModal = () => {
        // GA埋点
        GAEvents.aiChallengeGameHelpTip()
        setShowPlayTip(true)
    }

    return (
        <div ref={targetRef} className="game-page">
            <div className="global-page-background-img"
                 style={{backgroundImage: `url(${gameState == 3 ? (theme?.gameBg ?? imgUrls.gameBgSuccessIconUrl) : (theme?.gameBg ?? imgUrls.gamePageBgIconUrl)})`}}/>
            {/*顶部标题栏*/}
            <div className="top-title-container"
                 style={{backgroundImage: `url(${theme?.gameTopBarBg ?? imgUrls.titleBarBgUrl})`}}>
                <img onClick={handleBackButton} className="height-30 width-30 margin-left-13 object-fit-contain"
                     src={theme?.gameTopBackBtn ?? imgUrls.goBackIconUrl} alt="pic"/>
                <div
                    className="font-size-20 color-white text-center position-fixed position-left-50-percent transform-rotate-minus-50 my-roboto-medium">Level {aiLevel}</div>
                <img onClick={showHowToPlayModal} className="height-30 width-30 object-fit-contain margin-left-auto"
                     src={theme?.gameQuestionBtn ?? imgUrls.gameTipIconUrl}
                     alt="pic"/>
                <img onClick={showSettingModal}
                     className="height-30 width-30 object-fit-contain margin-left-8 margin-right-10"
                     src={theme?.gameSettingBtn ?? imgUrls.settingIconUrl}
                     alt="pic"/>
            </div>
            {/* ai显示顶部栏 或者 倒计时进度框*/}
            {gameState === 3 ? undefined :
                <AiTopBar squares={squares}/>}

            {/*九宫格字母界面card*/}
            <div>
                <div
                    className={`margin-top-32  ${gameState === 3 ? 'success-card-challenge-background' : ''}`}
                    style={successCardStyle}
                >
                    {/*如果是ai对战胜利，在九宫格顶部显示头像和YOU WIN*/}
                    {gameState === 3 &&
                        <div className="margin-top-8 display-flex-column display-flex-align-items-center">
                            <img className="challenge-win-star-img" src={imgUrls.challengeWinStarPicUrl} alt="pic"/>
                            <div className="challenge-success-avatar-container margin-top-8">
                                <img className="success-card-you-win-avatar-challenge"
                                     src={user?.avatarBase64 ?? imgUrls.defaultAvatarUrl}
                                     alt="pic"/>
                                <img className="success-card-you-win-avatar-flower-challenge"
                                     src={imgUrls.gameSuccessAvatarFlower} alt="pic"/>
                            </div>
                            <img className="success-card-you-win-text position-fixed margin-top-85"
                                 src={imgUrls.youWinTextPic}
                                 alt="pic"/>
                        </div>
                    }
                    {/*游戏九宫格界面*/}
                    <GridLetterCard isScreenshotting={isScreenshotting} wordList={inputWords} correctWord={correctWord}
                                    gameState={gameState}
                                    style={{top: `${(gameState === 3) ? '180px' : ''}`}}
                    />
                </div>
                {/*键盘或者成功后的提示文字*/}
                {gameState === 3 ?
                    <div className="width-285 color-white margin-top-20 my-roboto-medium margin-left-right-auto ">
                        <div className="display-flex-row display-flex-align-items-center">
                            {/*连续胜利次数，显示aiLevel*/}
                            <div style={{color: theme?.gameDescriptionTextColor}}
                                 className="my-roboto-regular font-size-16">Number of consecutive victories:
                            </div>
                            <div style={{color: theme?.gameDescriptionTextColor}}
                                 className="font-size-20 my-roboto-bold text-italic margin-left-4">{aiLevel}</div>
                        </div>
                        <div className="display-flex-row display-flex-align-items-center margin-top-4">
                            {/*猜词数量*/}
                            <div style={{color: theme?.gameDescriptionTextColor}}
                                 className="my-roboto-regular font-size-16">Number of guessing attempts:
                            </div>
                            <div style={{color: theme?.gameDescriptionTextColor}}
                                 className="font-size-20 my-roboto-bold text-italic margin-left-4">{inputWords.length}</div>
                        </div>
                        <div className="display-flex-row display-flex-align-items-center margin-top-4">
                            {/*玩游戏的时间，当前这一局的时间，这里的时间是玩家进入这一关卡开始计时到胜利过了多久*/}
                            <div style={{color: theme?.gameDescriptionTextColor}}
                                 className="my-roboto-regular font-size-16">Game duration:
                            </div>
                            <div style={{color: theme?.gameDescriptionTextColor}}
                                 className="font-size-20 my-roboto-bold text-italic margin-left-4">{countUp}</div>
                            <div style={{color: theme?.gameDescriptionTextColor}}
                                 className="my-roboto-regular text-italic font-size-16">s
                            </div>
                        </div>
                        <div className="display-flex-row margin-top-20">
                            {theme?.gameShareBtn ?
                                <div onClick={captureScreenshot}
                                     className="width-43 height-43 border-radius-5 display-flex-row display-flex-justify-content-center display-flex-align-items-center">
                                    <img className="width-43 height-43" src={theme?.gameShareBtn} alt="pic"/>
                                </div>
                                :
                                <div onClick={captureScreenshot}
                                     className="width-43 height-43 bg-color-white border-radius-5 display-flex-row display-flex-justify-content-center display-flex-align-items-center">
                                    <img className="width-18 height-18" src={imgUrls.shareIconBlueUrl} alt="pic"/>
                                </div>}
                            <div onClick={toChallengePage}
                                 style={theme?.gamePlayChallengeBtnBg ? {
                                     backgroundImage: `url(${theme?.gamePlayChallengeBtnBg})`,
                                     backgroundSize: 'cover',
                                     backgroundRepeat: "no-repeat"
                                 } : {}}
                                 className={`${theme?.gamePlayChallengeBtnBg ? '' : 'play-challenge-btn-bg'} margin-left-8 width-248 border-radius-5 height-43 display-flex-row display-flex-justify-content-center display-flex-align-items-center`}>
                                <div style={{color: theme?.gamePlayChallengeBtnBg ? 'white' : ''}}
                                     className="font-size-16 my-roboto-medium color-blue">Next level
                                </div>
                                <img className="width-18 height-18 margin-left-8"
                                     src={theme ? imgUrls.arrowRightRoundWhiteIcon : imgUrls.arrowRightCircleIconUrl}
                                     alt="icon"/>
                            </div>
                        </div>
                    </div>
                    :
                    <Keyboard
                        correctWord={correctWord}
                        inputWords={inputWords}
                        gameState={gameState}
                        handleGameState={handleGameState}
                        addWordToInputList={addWordToInputList}
                        wrongLetters={wrongLetters}/>}
            </div>
            {/*challenge游戏失败时的弹窗*/}
            <ChallengeGameFailDialog key={"challengeGameFailDialog"}
                                     bestStreak={bestStreak}
                                     isOpen={showAiGameFailTip} switchPage={switchPage}
                                     onClose={handleCloseFailModal} correctWord={correctWord}/>
            {/*设置的弹窗*/}
            <SettingModal key="homeSettingModal" isOpen={showSetting} onClose={() => setShowSetting(false)}
                          onShowPlayTip={showPlayTipModal}/>
            {/*游戏提示的弹窗*/}
            <AIPlayTipModal key="AiPlayTipModal" isOpen={showPlayTip} onClose={() => setShowPlayTip(false)}/>
            <ExitGameConfirmDialog isOpen={showExitConfirm} onConfirm={confirmExit}
                                   onCancel={() => setShowExitConfirm(false)}/>
        </div>
    );
};

export default AIGamePage;
